module.exports = __webpack_public_path__ + "img/lose_lottery0_mall.68373015.png";